import { render, staticRenderFns } from "./KomunitasKami.vue?vue&type=template&id=4e272a57&scoped=true"
import script from "./KomunitasKami.vue?vue&type=script&lang=js"
export * from "./KomunitasKami.vue?vue&type=script&lang=js"
import style0 from "./KomunitasKami.vue?vue&type=style&index=0&id=4e272a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e272a57",
  null
  
)

export default component.exports